import { Header, Footer } from '@/components/layout'
import { SEO } from '@/components/seo'

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-surface-950">
      <SEO
        title="Contact Us"
        description="Get in touch with JumpstoneAuth. Contact our sales team for demos, support team for help, or explore partnership opportunities."
        canonical="/contact"
      />
      <Header />
      <main className="pt-24 pb-16">
        <div className="mx-auto max-w-7xl section-padding">
          <h1 className="text-4xl font-bold text-white mb-4">Contact Us</h1>
          <p className="text-lg text-surface-400">We'd love to hear from you</p>
        </div>
      </main>
      <Footer />
    </div>
  )
}

